var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCollectionOfferIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 7.375C7 8.00781 6.48438 8.5 5.875 8.5H2.125C1.49219 8.5 1 8.00781 1 7.375V3.625C1 3.01562 1.49219 2.5 2.125 2.5H5.875C6.48438 2.5 7 3.01562 7 3.625V7.375ZM2.125 3.625V7.375H5.875V3.625H2.125ZM11.125 7.75V5.875H7.75V4.75H11.125C11.7344 4.75 12.25 5.26562 12.25 5.875V7.75H11.125ZM3.25 6.25V4.75H4.75V6.25H3.25ZM14.875 8.5C15.4844 8.5 16 9.01562 16 9.625V13.375C16 14.0078 15.4844 14.5 14.875 14.5H11.125C10.4922 14.5 10 14.0078 10 13.375V9.625C10 9.01562 10.4922 8.5 11.125 8.5H14.875ZM14.875 13.375V9.625H11.125V13.375H14.875ZM5.875 9.25V11.125H9.25V12.25H5.875C5.24219 12.25 4.75 11.7578 4.75 11.125V9.25H5.875ZM13.75 10.75V12.25H12.25V10.75H13.75Z",
    fill: "#C5C5C5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollectionOfferIcon);
export default __webpack_public_path__ + "static/media/collectionOfferIcon.462f2ad92fefd8ffaf4fb510dddf9d9b.svg";
export { ForwardRef as ReactComponent };